// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-containers-TopList-__styles-module___footer","main":"src-containers-TopList-__styles-module___main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TopList/styles.module.css
// module id = 897
// module chunks = 0